import React, { useState } from "react";
import {
  FormControl,
  Grid,
  TextField,
  Typography,
  Button,
  Box,
} from "@mui/material";
import Loader from "../component/loading-screen/Loader";
import { apiErrorToast } from "../utils/ToastUtil";

const LeasePayment = () => {
  const [selectedValue, setSelectedValue] = useState("");
  const [amount, setAmount] = useState("");
  const [id, setId] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!id || !amount || !password) {
      apiErrorToast("Please fill all the fields.");
      return;
    }
  };

  return (
    <Box
      sx={{
        p: 4,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        bgcolor: "#F7F4EF",
      }}
    >
      <Box
        sx={{
          p: 4,
          width: "100%",
          maxWidth: 500,
          borderRadius: "16px",
          bgcolor: "white",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Typography
          variant="h4"
          align="center"
          sx={{ fontWeight: "bold", color: "#D48628", mb: 2 }}
        >
          Lease Payment
        </Typography>

        <Box display="flex" justifyContent="center" my={2}>
          {loading && <Loader loading={loading} />}
        </Box>

        {/* Form Fields */}
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <TextField
                label="Id"
                size="small"
                sx={{
                  "& .MuiInputBase-input": {
                    fontSize: "12px",
                    color: "black",
                  },
                }}
                value={id}
                onChange={(e) => setId(e.target.value)}
                required
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl fullWidth>
              <TextField
                label="Amount"
                size="small"
                sx={{
                  "& .MuiInputBase-input": {
                    fontSize: "12px",
                    color: "black",
                  },
                }}
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                required
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl fullWidth>
              <TextField
                label="Password"
                size="small"
                sx={{
                  "& .MuiInputBase-input": {
                    fontSize: "12px",
                    color: "black",
                  },
                }}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </FormControl>
          </Grid>
        </Grid>

        {/* Submit Button */}
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={loading}
            sx={{ width: "100%" }}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default LeasePayment;
